/**
 * @desc 获取全局或基地设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.SettingDetailSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QuerySettingDetailResponse>>> {
  return defHttp.post({
    url: '/wap/setting/detail/search',
    data,
  });
}

export function mock(
  data: defs.SettingDetailSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QuerySettingDetailResponse>>> {
  return defHttp.post({
    url: '/mock/wap/setting/detail/search',
    data,
  });
}
